import firebase from 'firebase/app'
import _ from 'lodash'

const findItem = async (merchantKey, firebaseKey) => {
  return firebase
    .database()
    .ref(`items/${merchantKey}/${firebaseKey}`)
    .once('value')
}

const deleteItem = async (merchantKey, firebaseKey) => {
  const updates = {}

  updates[`items/${merchantKey}/${firebaseKey}`] = null

  return firebase
    .database()
    .ref()
    .update(updates)
}

const generateKey = merchantKey => {
  return firebase
    .database()
    .ref(`items/${merchantKey}`)
    .push().key
}

const updateItems = async (merchantKey, items) => {
  const updates = {}
  const optionUpdates = {}

  items.forEach(item => {
    const { key: itemKey, options = [], ...itemFields } = item

    if (item.isDelete) {
      updates[`items/${merchantKey}/${itemKey}`] = null
    } else {
      _.forEach(itemFields, (val, name) => {
        updates[`items/${merchantKey}/${itemKey}/${name}`] = val
      })
    }

    _.forEach(options, (option, optionKey) => {
      if (option) {
        optionUpdates[`items/${merchantKey}/${itemKey}/options/${optionKey}/order`] = option.order
      } else {
        optionUpdates[`items/${merchantKey}/${itemKey}/options/${optionKey}`] = null
      }
    })
  })

  await firebase
    .database()
    .ref()
    .update(updates)

  await firebase
    .database()
    .ref()
    .update(optionUpdates)
}

export default {
  findItem,
  deleteItem,
  generateKey,
  updateItems,
}



// WEBPACK FOOTER //
// ./src/models/item.js